export const absoluteValue = (value): string => {
    return `${Math.abs(value).toLocaleString('de-DE')}`;
};
